// シンプルなボタンコンポーネント。
// fork_webapp_react の Button の variant/size API に合わせつつ、
// 長押し・toast などの機能は本アプリでは不要のため省いている。

export type ButtonVariant = 'blue' | 'white' | 'red'
export type ButtonSize = 'sm' | 'md' | 'lg' | 'default'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  className?: string
  children: React.ReactNode
}

function getBaseClasses(variant: ButtonVariant): string {
  const baseCommon =
    'relative rounded-lg transition-colors duration-200 disabled:bg-gray-300 disabled:cursor-not-allowed'
  switch (variant) {
    case 'white':
      return `${baseCommon} bg-white hover:bg-gray-200 text-black border`
    case 'red':
      return `${baseCommon} bg-red-400 hover:bg-red-600 text-white`
    case 'blue':
    default:
      return `${baseCommon} bg-blue-400 hover:bg-blue-600 text-white`
  }
}

function getSizeClasses(size: ButtonSize): string {
  switch (size) {
    case 'sm':
      return 'px-3 py-1.5 text-sm'
    case 'md':
      return 'px-4 py-2.5 font-medium'
    case 'lg':
      return 'px-6 py-4 text-xl font-bold'
    case 'default':
    default:
      return 'px-4 py-2'
  }
}

export default function Button({
  variant = 'blue',
  size = 'default',
  className = '',
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={`${getBaseClasses(variant)} ${getSizeClasses(size)} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
